import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface Empresa {
  id: number;
  nombre: string;
  descripcion: string;
}

interface EmpresaState {
  empresaSeleccionada: Empresa | null;
  setEmpresa: (empresa: Empresa | null) => void;
  clearEmpresa: () => void;
}

export const empresaOptions: Empresa[] = [
  {
    id: 2,
    nombre: 'Premium Shellfish',
    descripcion: 'Empresa 2 — línea premium de mariscos',
  },
  {
    id: 70,
    nombre: 'Carpier Ahumados',
    descripcion: 'Empresa 70 — surtido artesanal de ahumados',
  },
];

export const useEmpresaStore = create<EmpresaState>()(
  persist(
    (set) => ({
      empresaSeleccionada: null,
      setEmpresa: (empresa) => set({ empresaSeleccionada: empresa }),
      clearEmpresa: () => set({ empresaSeleccionada: null }),
    }),
    {
      name: 'empresa-seleccionada',
    }
  )
);
